// Copyright (c) Bentley Systems
import { MatchCodeItem } from "./match-code-item";
import { MatchCodeParameter } from "./match-code-parameter";

export class MatchCode {
  public matchCodeId: number | undefined;
  public name: string | undefined;
  public type: string | undefined;
  public items: MatchCodeItem[] = [];
  public efMatchCodeParameters: MatchCodeParameter[] = [];
  public displayNull: boolean = true;

  constructor(initializer?: any) {
    if (initializer.matchCodeId) {
      this.matchCodeId = initializer.matchCodeId;
    }
    if (initializer.name) {
      this.name = initializer.name;
    }
    if (initializer.type) {
      this.type = initializer.type;
    }
    if (initializer.efEnumMatchCodeItems) {
      this.items = initializer.efEnumMatchCodeItems.map(
        (item: any) => new MatchCodeItem(item),
      );
    }
    if (initializer.efMatchCodeParameters) {
      this.efMatchCodeParameters = initializer.efMatchCodeParameters.map(
        (item: any) => new MatchCodeParameter(item),
      );
    }
    if (
      initializer.efSimpleMatchCode !== undefined &&
      initializer.efSimpleMatchCode !== null &&
      initializer.efSimpleMatchCode.displayNull !== undefined &&
      initializer.efSimpleMatchCode.displayNull !== null
    ) {
      this.displayNull = initializer.efSimpleMatchCode.displayNull;
    }
  }
}
